export const DEFAULT_PAGE_NUMBER = 0

export const COURSE_OPTIONS = [
  { value: 'K66', label: 'K66' },
  { value: 'K65', label: 'K65' },
  { value: 'K64', label: 'K64' },
  { value: 'K63', label: 'K63' },
  { value: 'K62', label: 'K62' },
  { value: 'K61', label: 'K61' },
]
export const ERROR_REPORT_OPTIONS = {
  STATUS: [
    { value: 'waiting', label: 'Chờ phản hồi', color: 'secondarygray' },
    { value: 'responded', label: 'Đã phản hồi', color: 'green' },
    { value: 'rejected', label: 'Đã từ chối', color: 'buttonred' },
  ],
  OS: [
    { value: 'ios', label: 'ios' },
    { value: 'android', label: 'android' },
    { value: 'macos', label: 'macos' },
    { value: 'windows', label: 'windows' },
  ],
}

export const BOOKS_PACKAGES_OPTIONS = [
  { value: 'SachCoBan', label: 'Gói sách cơ bản' },
  { value: 'DeCuong', label: 'Đề cương học phần' },
  { value: 'DeCuong_SDH', label: 'Đề cương - Sau đại học' },
  { value: 'NghienCuuKhoaHoc', label: 'Tài liệu NCKH' },
  { value: 'SlideBaiGiang', label: 'Slide bài giảng' },
]

export const BOOK_DATA_COLLECTION = 'book-data'
export const USER_DATA_COLLECTION = 'user-data'
export const BUG_REPORT_DATA_COLLECTION = 'bug-report'
export const CONFIG_DATA_COLLECTION = 'configuration'

export const USER_STATE_LOCK = 'Đã khoá'
export const USER_STATE_DEFAULT = 'Đã kích hoạt'

export const CONFIG = {
  category: 'categorize',
}
export const ADMIN_ROLE = 'CAIT'

export const BOOKS_PACKAGE_STORAGE_KEY = {
  BOOK_PACKAGE_UUID: 'BOOK_PACKAGE_UUID',
}
